/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { DynamicIconProps } from '../../../icon/icon.types';
import { Icon } from '../../icon';

const Play24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g className="Play 25">
      <path
        fill="#0E0E0E"
        d="M12.34 6.788c.88.56.88 1.864 0 2.424L5.15 13.78c-.935.596-2.15-.089-2.15-1.212V3.432C3 2.309 4.215 1.625 5.15 2.22l7.19 4.568Z"
        className="Main"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: Play24,
  md: Play24,
  lg: Play24,
  xl: Play24,
  xxl: Play24,
  xxxl: Play24,
};

export const PlayIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: DynamicIconProps) => {
  return (
    <Icon
      data-testid={testId || 'play-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
